import React, { PureComponent } from 'react';
import { getRecommendCode } from 'utilsRecommendCode';
import './index.less';
import kefu from '../assets/kefu.png';
import kefu2 from '../assets/kefu2.png';
import { webEntry } from 'utilsRecommendCode';
import urlConfig from 'Url';

class OnlineService extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      startX: '',
      startY: '',
      startLeft: '',
      startTop: '',
    };
  }

  componentDidMount() {
    this.customerService.addEventListener(
      'touchstart',
      this.handlerTouchstart,
      {
        passive: false,
      }
    );
    this.customerService.addEventListener('touchmove', this.handlerTouchmove, {
      passive: false,
    });
    this.customerService.addEventListener('touchend', this.handlerTouchend, {
      passive: false,
    });
  }

  componentWillUnmount() {
    this.customerService.removeEventListener(
      'touchstart',
      this.handlerTouchstart
    );
    this.customerService.removeEventListener(
      'touchmove',
      this.handlerTouchmove
    );
    this.customerService.removeEventListener('touchend', this.handlerTouchend);
  }

  gotoCustomer = () => {
    window.sessionStorage.setItem(
      'htmlFontSize',
      document.getElementsByTagName('html')[0].style.fontSize
    );

    // 跳转到人工客服 number 0:App 1:触屏 2: 小程序
    if (webEntry() === 0) {
      window.location.href = urlConfig.online_service_app_url;
    } else if (webEntry() === 1) {
      window.location.href = urlConfig.online_service_web_url;
    } else if (webEntry() === 2) {
      window.location.href = urlConfig.online_service_wx_url;
    }
  };

  handlerTouchstart = e => {
    this.setState({
      startX: e.touches[0].clientX,
      startY: e.touches[0].clientY,
      startLeft: e.target.parentNode.offsetLeft,
      startTop: e.target.parentNode.offsetTop,
    });
  };

  handlerTouchmove = e => {
    e.preventDefault();
    const { startX, startY, startLeft, startTop } = this.state;
    let actmoveX = e.touches[0].clientX - startX;
    let actmoveY = e.touches[0].clientY - startY;

    e.target.parentNode.style.left =
      startLeft + actmoveX >
      window.innerWidth - e.target.parentNode.offsetWidth - 10
        ? window.innerWidth - e.target.parentNode.offsetWidth - 10 + 'px'
        : startLeft + actmoveX - 10 < 0
        ? 10 + 'px'
        : startLeft + actmoveX + 'px';

    e.target.parentNode.style.top =
      startTop + actmoveY >
      window.innerHeight - e.target.parentNode.offsetHeight - 35
        ? window.innerHeight - e.target.parentNode.offsetHeight - 35 + 'px'
        : startTop + actmoveY - 10 < 0
        ? 10 + 'px'
        : startTop + actmoveY + 'px';
  };

  handlerTouchend = e => {
    // console.log(e);
  };

  render() {
    // const { referral } = this.state;
    const { lang } = this.props;
    return (
      <div
        className="customerServ"
        ref={customerService => (this.customerService = customerService)}
        role="button"
        aria-label={lang.onliveService}
        onClick={() => this.gotoCustomer()}
      >
        <img className="img1" src={kefu} alt="图标" />
        <img className="img2" src={kefu2} alt="图标" />
      </div>
    );
  }
}

export default OnlineService;



// WEBPACK FOOTER //
// ./src/components/OnlineService/index.js